import { Injectable } from "@angular/core";
import * as _ from "lodash";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class LocalStorageService {

  exceptionKeyList = [
    'cookiefirst-consent',
    'cookiefirst-id',
    'api-url'
  ];

  apiUrlSubject = new BehaviorSubject<string>('');

  clear(): void {
    this.clearWithExceptions(['api-url']);
  }

  clearWithExceptions(exceptionList?: string[]): void {
    if(_.isEmpty(exceptionList)) exceptionList = this.exceptionKeyList;

    const length = localStorage.length;
    const keysToRemove: string[] = [];

    for(let i = 0; i < length; ++i) {
      const key = localStorage.key(i);

      if(!exceptionList!.some((exceptionKey: string) => exceptionKey === key))
        keysToRemove.push(key!);
    }

    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
  }

  set apiUrl(apiUrl: string) {
    this.apiUrlSubject.next(apiUrl);
    localStorage.setItem('api-url', apiUrl);
  }

  get apiUrl(): string {
    const apiUrlLocalStorage = localStorage.getItem('api-url');
    if(!_.isEmpty(apiUrlLocalStorage)) this.apiUrl = apiUrlLocalStorage as string;
    return this.apiUrlSubject.value;
  }

  get apiUrl$(): Observable<string> {
    return this.apiUrlSubject.asObservable();
  }
}